/**
 * @flow
 * @relayHash ea77286b3be46db39c9fb01b1fa0b676
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEmailTemplatefieldsQueryVariables = {|
  id: string
|};
export type getEmailTemplatefieldsQueryResponse = {|
  +hyblastEditor: {|
    +fields: ?$ReadOnlyArray<{|
      +id: string,
      +label: string,
      +type: string,
      +value: ?string,
      +field: string,
    |}>,
    +templateId: string,
    +id: string,
    +name: ?string,
    +subject: ?string,
    +lastTestEmails: string,
    +lastTestPhones: ?string,
    +rawMacrosHtml: string,
    +substitutedMacrosHtml: string,
  |}
|};
export type getEmailTemplatefieldsQuery = {|
  variables: getEmailTemplatefieldsQueryVariables,
  response: getEmailTemplatefieldsQueryResponse,
|};
*/


/*
query getEmailTemplatefieldsQuery(
  $id: ID!
) {
  hyblastEditor(id: $id) {
    fields {
      id
      label
      type
      value
      field
    }
    templateId
    id
    name
    subject
    lastTestEmails
    lastTestPhones
    rawMacrosHtml
    substitutedMacrosHtml
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "hyblastEditor",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "HyblastEditor",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "fields",
        "storageKey": null,
        "args": null,
        "concreteType": "EditorField",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "label",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "value",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "field",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "templateId",
        "args": null,
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "subject",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lastTestEmails",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "lastTestPhones",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rawMacrosHtml",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "substitutedMacrosHtml",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEmailTemplatefieldsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEmailTemplatefieldsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEmailTemplatefieldsQuery",
    "id": null,
    "text": "query getEmailTemplatefieldsQuery(\n  $id: ID!\n) {\n  hyblastEditor(id: $id) {\n    fields {\n      id\n      label\n      type\n      value\n      field\n    }\n    templateId\n    id\n    name\n    subject\n    lastTestEmails\n    lastTestPhones\n    rawMacrosHtml\n    substitutedMacrosHtml\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8d3101f7f49447ccb03e4c0169161f67';
module.exports = node;
